import qs from 'qs'

/** tpDocumento "Minuta de Contrato" */
export const TP_DOCUMENTO_MINUTA_CONTRATO = 20

/** Campos usados na tabela e filtros (sem task_id nem agregação de parcelas por linha). */
export const CONTR_FORN_LIST_FIELDS = {
  compraCotacao_id: 'compraCotacao_id',
  meioPgto_id: 'meioPgto_id',
  conta_id: 'conta_id',
  '(SELECT compraStatus_id FROM compraCotacao WHERE compraCotacao.compraCotacao_id = contrForn.compraCotacao_id LIMIT 1)': 'compraStatus_id',
  '(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = contrForn.orcItem_id LIMIT 1)': 'orcItem_desc',
  '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = contrForn.contrForn_parteId AND contrForn.contrForn_parteTab = "pf" LIMIT 1)': 'contratado_nomePf',
  '(SELECT pj_razaosocial FROM pj WHERE pj.pj_id = contrForn.contrForn_parteId AND contrForn.contrForn_parteTab = "pj" LIMIT 1)': 'contratado_nomePj',
  '(SELECT contrFornStatus_nome FROM contrFornStatus WHERE contrFornStatus.contrFornStatus_id = contrForn.contrFornStatus_id LIMIT 1)': 'contrFornStatus_nome',
  '(SELECT contrFornTp_nome FROM contrFornTp WHERE contrFornTp.contrFornTp_id = contrForn.contrFornTp_id LIMIT 1)': 'contrFornTp_nome',
  // id_oikos em viewOrcRubr_taxonomia2 é orcRubr_id, não orcItem_id — usar a view do item
  '(SELECT nivel2 FROM viewRubr_OrcItem WHERE orcItem_id = contrForn.orcItem_id LIMIT 1)': 'centroDeCusto',
  '(SELECT nivel2_id FROM viewRubr_OrcItem WHERE orcItem_id = contrForn.orcItem_id LIMIT 1)': 'centroDeCustoRubr_id',
  '(SELECT tpMinuta_nome FROM tpMinuta WHERE tpMinuta.tpMinuta_id = contrForn.tpMinuta_id LIMIT 1)': 'tpMinuta_nome',
}

/** Usado no modal de info (contexto de projeto). */
export const CONTR_FORN_PROJ_NOME_FIELD = {
  '(SELECT proj_nome FROM proj WHERE orcRubr_id = (SELECT orcRubr_id FROM orcItem WHERE orcItem_id = contrForn.orcItem_id LIMIT 1) LIMIT 1)': 'proj_nome',
}

export const buildContrFornListFields = (includeProjNome = false) => (
  includeProjNome
    ? { ...CONTR_FORN_LIST_FIELDS, ...CONTR_FORN_PROJ_NOME_FIELD }
    : CONTR_FORN_LIST_FIELDS
)

export const buildContrFornQueryString = ({
  user,
  proj_orcRubrId,
  proj_coord,
  filterMeusFornecedores,
}) => {
  if (!user) return null

  const data = { contrForn_ativo: 1 }

  if (proj_orcRubrId) {
    data.orcItem_id = `!IN!(SELECT orcItem_id FROM orcItem WHERE orcRubr_id IN (SELECT id_oikos FROM viewOrcRubr_taxonomia2 WHERE nivel3_id = ${proj_orcRubrId}))`
  }

  if (user.perm_id === 1) {
    if (filterMeusFornecedores) {
      data.pf_id = Number(user.pf_id)
    }
  } else if (filterMeusFornecedores) {
    data.pf_id = Number(user.pf_id)
  } else if (Number(user.pf_id) !== Number(proj_coord) && Number(user.pf_id) !== 104) {
    data.pf_id = Number(user.pf_id)
  }

  return qs.stringify({
    action: 'get',
    table: 'contrForn',
    data,
    fields: buildContrFornListFields(Boolean(proj_orcRubrId)),
  })
}

/** Parcelas do acordeon: colunas base + borderô em lote (sem subconsultas por linha). */
export const fetchContrFornEventosWithBordero = async (oikosApi, contrFornId) => {
  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'contrFornEvento',
    data: {
      contrForn_id: contrFornId,
      contrFornEvento_ativo: 1,
    },
    fields: {},
  })}`)

  const eventos = res.data || []
  const eventoIds = eventos.map((evento) => evento.contrFornEvento_id).filter(Boolean)
  if (!eventoIds.length) return eventos

  try {
    const bdroRes = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'bdro',
      data: {
        bdro_tabRef: 'contrFornEvento',
        bdro_tabId: `!IN!(${eventoIds.join(',')})`,
        bdro_ativo: 1,
      },
      fields: {},
    })}`)

    const bdroByEventoId = {}
    ;(bdroRes.data || []).forEach((bdro) => {
      const tabId = String(bdro.bdro_tabId)
      const existing = bdroByEventoId[tabId]
      if (!existing || Number(bdro.bdro_id) > Number(existing.bdro_id)) {
        bdroByEventoId[tabId] = bdro
      }
    })

    return eventos.map((evento) => {
      const bdro = bdroByEventoId[String(evento.contrFornEvento_id)]
      const bdroId = evento.bdro_id ?? bdro?.bdro_id ?? null
      const liberacaoAutomaticaComBordero = Number(evento.contrFornEvento_liberacaoAutomatica) === 1
        && Number(bdroId)
      return {
        ...evento,
        bdro_id: bdroId,
        bdro_dtVenc: bdro?.bdro_dtVenc ?? null,
        bdro_dtQuit: bdro?.bdro_dtQuit ?? null,
        contrFornEvento_aprovLiberado: liberacaoAutomaticaComBordero
          ? 1
          : evento.contrFornEvento_aprovLiberado,
      }
    })
  } catch (error) {
    console.error('Failed to fetch borderô das parcelas:', error)
    return eventos
  }
}

const TP_DOCUMENTO_EVIDENCIA = 24
const TP_DOCUMENTO_NOTA_FISCAL = 27

const eventoPrecisaArquivos = (evento) => (
  Number(evento.contrFornEvento_aprovLiberado) === 1
  || Number(evento.contrFornEvento_liberacaoAutomatica) === 1
)

const fetchDocumentoVincArquivos = async (oikosApi, tabRef, tabIds) => {
  const ids = [...new Set(tabIds.map((id) => Number(id)).filter(Boolean))]
  if (!ids.length) return []

  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'documentoVinc',
    data: {
      documentoVinc_tabRef: tabRef,
      documentoVinc_tabId: `!IN!(${ids.join(',')})`,
    },
    fields: {
      documentoVinc_id: 'documentoVinc_id',
      documentoVinc_tabId: 'documentoVinc_tabId',
      documento_id: 'documento_id',
      '(SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1)': 'tpDocumento_id',
      '(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_tabId = documentoVinc.documento_id ORDER BY arquivo_id DESC LIMIT 1)': 'arquivo_caminho',
    },
  })}`)

  return Array.isArray(res?.data) ? res.data : []
}

const groupVincsByTabId = (rows) => {
  const grouped = {}
  rows.forEach((row) => {
    const tabId = String(row.documentoVinc_tabId)
    if (!grouped[tabId]) grouped[tabId] = []
    grouped[tabId].push(row)
  })
  return grouped
}

/** Maior documento_id do tipo, com o arquivo mais recente já resolvido na consulta. */
const pickArquivoCaminho = (rows, tpDocumentoId) => {
  const matches = (rows || []).filter((row) => Number(row.tpDocumento_id) === tpDocumentoId)
  if (!matches.length) return null
  matches.sort((a, b) => (Number(b.documento_id) || 0) - (Number(a.documento_id) || 0))
  return matches[0].arquivo_caminho || null
}

export const enrichEventosWithArquivos = async (oikosApi, eventos = []) => {
  const liberados = eventos.filter(eventoPrecisaArquivos)
  if (!liberados.length) return eventos

  const [vincsEvento, vincsBdro] = await Promise.all([
    fetchDocumentoVincArquivos(
      oikosApi,
      'contrFornEvento',
      liberados.map((evento) => evento.contrFornEvento_id),
    ),
    fetchDocumentoVincArquivos(
      oikosApi,
      'bdro',
      liberados.map((evento) => evento.bdro_id),
    ),
  ])

  const vincsByEventoId = groupVincsByTabId(vincsEvento)
  const vincsByBdroId = groupVincsByTabId(vincsBdro)
  const arquivosById = {}

  liberados.forEach((evento) => {
    const vincsDoEvento = vincsByEventoId[String(evento.contrFornEvento_id)] || []
    const vincsDoBdro = vincsByBdroId[String(evento.bdro_id)] || []
    arquivosById[evento.contrFornEvento_id] = {
      arquivo_caminho_evidencia: pickArquivoCaminho(vincsDoEvento, TP_DOCUMENTO_EVIDENCIA),
      arquivo_caminho_nota_fiscal: pickArquivoCaminho(
        [...vincsDoEvento, ...vincsDoBdro],
        TP_DOCUMENTO_NOTA_FISCAL,
      ),
    }
  })

  return eventos.map((evento) => ({
    ...evento,
    ...(arquivosById[evento.contrFornEvento_id] || {}),
  }))
}

/** Campos do contrato usados em ações das parcelas (evita subconsultas no get de eventos). */
export const enrichEventosWithContrato = (eventos = [], contratoRow = {}) => (
  eventos.map((evento) => ({
    ...evento,
    orcItem_id: contratoRow.orcItem_id ?? evento.orcItem_id,
    contrForn_parteTab: contratoRow.contrForn_parteTab ?? evento.contrForn_parteTab,
    contrForn_parteId: contratoRow.contrForn_parteId ?? evento.contrForn_parteId,
    contrFornStatus_id: contratoRow.contrFornStatus_id ?? evento.contrFornStatus_id,
    meioPgto_id: contratoRow.meioPgto_id ?? evento.meioPgto_id,
    conta_id: contratoRow.conta_id ?? evento.conta_id,
  }))
)

/** IDs da tabela meioPgto (cotação rápida / liberação direta). */
export const MEIO_PGTO = {
  PIX: 1,
  TRANSFERENCIA: 2,
  DEBITO_EM_CONTA: 3,
  BOLETO: 4,
  GUIA_TRIBUTO: 5,
  CARTAO: 6,
  CHEQUE: 7,
  DINHEIRO: 8,
  OUTROS: 9,
}

export const MEIO_PGTO_DIRETO_IDS = [MEIO_PGTO.PIX, MEIO_PGTO.BOLETO, MEIO_PGTO.CARTAO]

export const isMeioPagamentoDiretoCotacaoRapida = (meioPgtoId) => (
  MEIO_PGTO_DIRETO_IDS.includes(Number(meioPgtoId) || 0)
)

/**
 * Busca o arquivo da minuta (tpDocumento 20) vinculada ao contrForn.
 * Retorna { arquivo_caminho, documento_desc } ou null.
 */
export const fetchMinutaContratoArquivo = async (oikosApi, contrFornId) => {
  const id = Number(contrFornId)
  if (!id) return null

  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'documento',
    data: {
      tpDocumento_id: TP_DOCUMENTO_MINUTA_CONTRATO,
      documento_id: `!IN!(SELECT documento_id FROM documentoVinc WHERE documentoVinc_tabRef = 'contrForn' AND documentoVinc_tabId = ${id})`,
    },
    fields: {
      documento_id: 'documento_id',
      documento_desc: 'documento_desc',
      '(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_tabId = documento.documento_id ORDER BY arquivo_id DESC LIMIT 1)': 'arquivo_caminho',
    },
  })}`)

  const rows = Array.isArray(res?.data) ? res.data : []
  if (!rows.length) return null

  const sorted = [...rows].sort(
    (a, b) => (Number(b.documento_id) || 0) - (Number(a.documento_id) || 0),
  )
  const latest = sorted.find((row) => row?.arquivo_caminho) || sorted[0]
  if (!latest?.arquivo_caminho) return null

  return {
    arquivo_caminho: latest.arquivo_caminho,
    documento_desc: latest.documento_desc || null,
  }
}
